"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useRef } from "react";
import { useLayout } from "../layout/LayoutContext";
import { useWave } from "@/hooks/useWave";
import { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveTabsMeme from "./MyStreamWaveTabsMeme";
import MyStreamWaveTabsDefault from "./MyStreamWaveTabsDefault";
import useDeviceInfo from "../../../../hooks/useDeviceInfo";
interface MyStreamWaveTabsProps {
  readonly wave: ApiWave;
}
export const MyStreamWaveTabs: React.FC<MyStreamWaveTabsProps> = t0 => {
  const $ = _c(12);
  const {
    wave
  } = t0;
  const {
    isMemesWave
  } = useWave(wave);
  const {
    registerRef
  } = useLayout();
  const {
    isApp
  } = useDeviceInfo();
  const tabsElementRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isApp || $[1] !== registerRef) {
    t1 = () => {
      if (isApp) {
        registerRef("tabs", null);
      }
    };
    t2 = [isApp, registerRef];
    $[0] = isApp;
    $[1] = registerRef;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== registerRef) {
    t3 = element => {
      tabsElementRef.current = element;
      registerRef("tabs", element);
    };
    $[4] = registerRef;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const setTabsRef = t3;
  if (isApp) {
    return null;
  }
  let t4;
  if ($[6] !== isMemesWave || $[7] !== wave) {
    t4 = <div className="tw-w-full tw-bg-iron-950"><div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-x-3">{isMemesWave ? <MyStreamWaveTabsMeme wave={wave} /> : <MyStreamWaveTabsDefault wave={wave} />}</div></div>;
    $[6] = isMemesWave;
    $[7] = wave;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== setTabsRef || $[10] !== t4) {
    t5 = <div className="tw-flex-shrink-0" ref={setTabsRef} id="tabs-container">{t4}</div>;
    $[9] = setTabsRef;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};